import axios from "axios";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { useLoaderStore } from "./LoadStore";

// Create an axios instance
const api = axios.create({
    baseURL: import.meta.env.VITE_BASE_PATH,
});

// 🔒 Optional: Add request interceptor (for auth tokens)
api.interceptors.request.use(
    (config) => {
        const isFormData = config.data instanceof FormData; 
        useLoaderStore.getState().setLoading(true);
        const token = localStorage.getItem("authToken") ?? localStorage.getItem("temptoken");
        if (token) {
            config.headers = {
                ...config.headers,
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
                "Content-Type": isFormData
                    ? "multipart/form-data"
                    : "application/json"
            };
        }
        return config;
    },
    (error) => Promise.reject(error)
);

// 🚦 Optional: Add response interceptor (for errors)
api.interceptors.response.use(
    (response) => {
        useLoaderStore.getState().setLoading(false);
        return response;
    },
    (error) => {
        useLoaderStore.getState().setLoading(false);
        if (!error.response) {
            toast.error("No Internet Connection! Please check your network.");
            return Promise.reject(error);
        }

        // ⏳ Timeout
        if (error.code === "ECONNABORTED") {
            toast.error("Request timed out. Please try again.");
            return Promise.reject(error);
        }
        console.warn("API Error -->>error", error);
        if (error.response?.status === 401) {
            toast.error("Unauthorized!");
            localStorage.removeItem("token");
            localStorage.removeItem("user");
            window.location.href = "/login";

        }
        else {
            if (error?.response?.data?.error) toast.error(error?.response?.data?.error);
        }
        return Promise.reject(error);
    }
);

export default api;
